export default "__VITE_ASSET__B8IgHLKb__"